import { CommandType } from '@iot-platform/models/i4b';
import { I4BCellType } from '../configurations';
import { I4bCellConcept } from '../enums';
import { HeaderType } from '../models';
import { I4BButtonColumn } from './i4b-button.column';

export class NteDeviceButtonColumn extends I4BButtonColumn {
  constructor() {
    super(
      {
        type: HeaderType.CALL_TO_ACTION,
        displayName: 'BUTTON',
        icon: ''
      },
      {
        concept: I4bCellConcept.DEVICES,
        isConfigurable: false,
        isDefault: true,
        isLink: false,
        position: '',
        sortProperty: '',
        width: 10,
        id: 'button',
        cell: {
          type: I4BCellType.CALL_TO_ACTION,
          bulkActions: [
            {
              order: 2,
              key: 'bulk_apply_template',
              label: 'DEVICES.DETAIL_DEVICE_CARD.IMPORT_FORM_TEMPLATE',
              enableConditions: [[{ key: 'canUpdateDevice', value: true }]],
              disableConditions: [],
              visibleConditions: []
            },
            {
              order: 3,
              key: `bulk_${CommandType.REFRESH}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.REFRESH.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 4,
              key: `bulk_${CommandType.SELFCONF}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.SELFCONF.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            /*
            {
              order: 5,
              key: `bulk_${CommandType.RESTART_GREENGRASS}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.RESTART_GREENGRASS.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 6,
              key: `bulk_${CommandType.RESTART_DEVICE}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.RESTART_DEVICE.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            }*/
          ],
          singleActions: [
            {
              order: 2,
              key: 'apply_template',
              label: 'DEVICES.DETAIL_DEVICE_CARD.IMPORT_FORM_TEMPLATE',
              enableConditions: [[{ key: 'canUpdateDevice', value: true }]],
              disableConditions: [],
              visibleConditions: []
            },
            {
              order: 3,
              key: `${CommandType.REFRESH}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.REFRESH.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 4,
              key: `${CommandType.SELFCONF}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.SELFCONF.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 5,
              key: `${CommandType.RESTART_GREENGRASS}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.RESTART_GREENGRASS.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 6,
              key: `${CommandType.RESTART_DEVICE}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.RESTART_DEVICE.toUpperCase()}`,
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            }
          ],
          visibleConditions: [],
          enableConditions: []
        }
      },
      { order: 1000 }
    );
  }
}
